import React from 'react';
import { SummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { NameControl } from './NameControl';
import { useGetFilteredParties } from './hooks/useGetFilteredParties';
import { DisplayPartyPurpose } from '../../../../../ui-toolkit/enums/ePartyPurpose';

export const FilteredPartiesSummary: React.FC = () => {
  const parties = useGetFilteredParties();
  return (
    <>
      {parties.map((party) => (
        <SummaryItem label={DisplayPartyPurpose[party.purpose]} tab="parties" key={party.id}>
          <NameControl party={party} intent="faded" />
        </SummaryItem>
      ))}
    </>
  );
};
